// extracted by mini-css-extract-plugin
export default {"artsContainer":"ArtGalleryPage_artsContainer__Wsn48"};